import { Stack } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const ContentStyled = styled(Stack)(({ theme }) => ({
  gap: 4,

  '.collapseText-text': {
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    'line-clamp': '2',
    '-webkit-box-orient': 'vertical',

    '&.collapseText-textAll': {
      display: 'inline',
      overflow: 'hidden',
    } as CSSObject,
  } as CSSObject,

  '.collapseText-button': {
    color: Colors.gray600,
    transition: theme.transitions.create('color'),

    '&:hover': {
      color: Colors.hover,
    },
  } as CSSObject,
}));
